import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";
import { Checkbox } from "../ui/checkbox";

// target: { mode: "one", eid, ename } | { mode: "all", count } | null
export function SendReportDialog({ target, onCancel, onConfirm }) {
  const [includeTeam, setIncludeTeam] = useState(false);
  useEffect(() => { if (target) setIncludeTeam(false); }, [target]);
  const all = target?.mode === "all";
  return (
    <AlertDialog open={!!target} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="send-report-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {all ? `Enviar informe a ${target.count} empleado${target.count === 1 ? "" : "s"}` : `Enviar informe a ${target?.ename || ""}`}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {all && target.count > 1 ? "Cada uno recibirá" : "Recibirá"} su Top 10 de oportunidades, un mensaje personalizado con IA y su informe personal en PDF.
            {all && " Tarda unos 10 segundos por persona."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <label className="flex items-start gap-3 rounded-md border border-slate-200 bg-slate-50 p-3 cursor-pointer" data-testid="send-report-include-team-label">
          <Checkbox
            checked={includeTeam}
            onCheckedChange={(v) => setIncludeTeam(!!v)}
            data-testid="send-report-include-team-checkbox"
            className="mt-0.5"
          />
          <span className="text-sm text-slate-700">
            <strong>Incluir PDF anónimo del equipo</strong>
            <span className="block text-xs text-slate-500 mt-0.5">
              Verá los datos de sus compañeros como «Compañero 1, 2, 3…» y su propia fila resaltada.
            </span>
          </span>
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="send-report-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => onConfirm(includeTeam)} data-testid="send-report-confirm">
            Enviar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
